"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var initialState = new _immutable.Map({});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchStoresStatusesActionTypes.SUCCESS, function (state, action) {
  return (0, _immutable.Map)(action.payload.data);
}), initialState);

exports.default = _default;
module.exports = exports.default;